import { authTokenVar, isAuthenticatedVar } from '../apollo/cache'

const logout = (): void => {
  isAuthenticatedVar(false)
  authTokenVar(``)
  //TODO: remove cookie

}

export default logout